import { Component, Input, OnInit } from '@angular/core';
import { FormArray, FormControl, FormGroup } from '@angular/forms';
import { jsonDeepParse } from 'src/app/functions/shared-functions';

@Component({
  selector: 'tm-dynamic-checklist',
  templateUrl: './tm-dynamic-checklist.component.html',
  styleUrls: ['./tm-dynamic-checklist.component.scss']
})
export class TmDynamicChecklistComponent implements OnInit {

  @Input() masters;
  @Input() form_group;
  @Input() section;
  @Input() field;
  @Input() disabled;

  constructor() { }

  ngOnInit(): void {
    console.log(this.masters)
  }
}
